import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';
import Logo from './Logo';

const PaymentReceipt = ({ receipt }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="space-y-4">
      <Card className="max-w-2xl mx-auto print:shadow-none" data-testid="receipt">
        <CardHeader className="border-b">
          <div className="flex justify-between items-start">
            <div className="flex items-center space-x-3">
              <Logo className="h-12 w-12" />
              <div>
                <h2 className="text-2xl font-bold text-gray-900">My MedMember</h2>
                <p className="text-sm text-gray-600">Rosas Medical Center</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-lg font-bold text-teal-600">PAYMENT RECEIPT</p>
              <p className="text-sm text-gray-600">Receipt #: {receipt.receipt_number}</p>
            </div>
          </div>
        </CardHeader>

        <CardContent className="pt-6 space-y-6">
          {/* Payment Details */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500 mb-1">Patient ID</p>
              <p className="font-medium">{receipt.patient_id}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 mb-1">Patient Name</p>
              <p className="font-medium">{receipt.patient_name}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 mb-1">Payment Date</p>
              <p className="font-medium">{new Date(receipt.payment_date).toLocaleString()}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 mb-1">Payment Method</p>
              <p className="font-medium capitalize">{receipt.payment_method.replace('_', ' ')}</p>
            </div>
          </div>

          {/* Description */}
          <div className="border-t pt-4">
            <p className="text-sm text-gray-500 mb-2">Description</p>
            <p className="text-gray-900">{receipt.description}</p>
          </div>

          {/* Amount */}
          <div className="border-t pt-4 flex justify-between items-center">
            <p className="text-lg font-medium text-gray-700">Total Amount Paid</p>
            <p className="text-3xl font-bold text-teal-600">${receipt.amount.toFixed(2)}</p>
          </div>

          {/* Footer */}
          <div className="border-t pt-4 text-sm text-gray-600">
            <p>Processed by: {receipt.processed_by_name}</p>
            <p className="mt-2 text-xs">This is an official receipt for your payment. Please keep it for your records.</p>
          </div>
        </CardContent>
      </Card>

      {/* Print Button */}
      <div className="flex justify-center print:hidden">
        <Button onClick={handlePrint} className="bg-teal-600 hover:bg-teal-700" data-testid="print-receipt-btn">
          <Printer className="h-4 w-4 mr-2" />
          Print Receipt
        </Button>
      </div>
    </div>
  );
};

export default PaymentReceipt;
